import { render } from "./Xano.vue?vue&type=template&id=e2459452"
import script from "./Xano.vue?vue&type=script&lang=js"
export * from "./Xano.vue?vue&type=script&lang=js"

import "./Xano.vue?vue&type=style&index=0&id=e2459452&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__